import React from 'react';
import { VitaminProgram } from './VitaminProgram';

const mockVitamins = [
    {
        slug: 'vitamin-d',
        name: 'Витамин D',
        description: 'Поддерживает иммунитет и здоровье костей.',
        icon: '/img/program-nutrition-image3.png',
    },
    {
        slug: 'magnesium',
        name: 'Магний',
        description: 'Снижает утомляемость, улучшает сон.',
        icon: '/img/program-nutrition-image1.png',
    },
    {
        slug: 'omega-3',
        name: 'Омега-3',
        description: 'Улучшает работу сердца и мозга.',
        icon: '/img/program-vitamins-image2.png',
    },
];

export const VitaminProgramPage: React.FC = () => {
    return <VitaminProgram month="первый" vitamins={mockVitamins} locked={true} />;
};
